import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/programs")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        href: `/orgs/${params.slug}/programs`,
        labelTranslationKey: "programsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
